import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { createDispute, fetchDisputeByRequest } from './api';

export const DISPUTES_KEY = ['disputes'] as const;

export function useDisputeByRequest(requestId: string, enabled = true) {
  return useQuery({
    queryKey: [...DISPUTES_KEY, requestId],
    queryFn: () => fetchDisputeByRequest(requestId),
    enabled: enabled && !!requestId,
  });
}

export function useCreateDispute() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ requestId, description, evidence }: { requestId: string; description: string; evidence?: string[] }) =>
      createDispute(requestId, { description, evidence }),
    onSuccess: (_data, { requestId }) => {
      qc.invalidateQueries({ queryKey: [...DISPUTES_KEY, requestId] });
      qc.invalidateQueries({ queryKey: ['requests'] });
    },
  });
}
